var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "form-control" }, [
    _c("label", [_vm._v(_vm._s(_vm.value.label))]),
    _vm._v(" "),
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.value.value,
          expression: "value.value"
        }
      ],
      ref: "input",
      attrs: { type: "text" },
      domProps: { value: _vm.value.value },
      on: {
        input: [
          function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.$set(_vm.value, "value", $event.target.value)
          },
          function($event) {
            return _vm.updateTextFacet()
          }
        ]
      }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }